<template>
  <!-- 新增商保 -->
  <div class="page_israGud">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>信息维护</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/successCaseSet' }">文档管理</el-breadcrumb-item>
          <el-breadcrumb-item>公司介绍新增/编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="addCompanyProfileForm">
          <el-form :model="formData" :rules="rules" ref="comForm" label-width="100px">
            <el-form-item label="公司主体" prop="CompanyName">
              <el-select v-model="CompanyName" placeholder="" clearable filterable @change="changeLeg">
                <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="{label:item.CompanyName,value:item.Id}"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本类型" prop="VerType">
              <el-select v-model="formData.VerType" placeholder="" clearable>
                <el-option label="集团版" value="集团版"></el-option>
                <el-option label="业务版" value="业务版"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="更新时间" prop="UpdataTime1">
              <el-date-picker type="date" placeholder="选择日期" v-model="formData.UpdataTime1"></el-date-picker>
            </el-form-item>
            <el-form-item label="管理员" prop="Manager">
              <el-select v-model="formData.Manager" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'Manager','ManagerId')}">
                <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="logo:">
              <el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false" :on-change="(file, fileList) => { handleAvatarSuccess(file, fileList) }">
                <img v-if="formData.LogUrl" :src="imgHead + formData.LogUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="附件" prop="AttachmentUrl">
              <div class="upload_box">
                <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
                  <el-button size="small" type="success">上传附件</el-button>
                </el-upload>
              </div>
            </el-form-item>

            <div class="btnBox">
              <el-button type="success" @click="submitForm" v-preventReClick>保存</el-button>
              <el-button @click="backHandle">取消</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        formData: {
          Id: '',
          LegalId: '', //主体ID
          CompanyName: '', //公司名称
          VerType: '', //版本类型
          UpdataTime1: '', //更新时间
          Manager: '', //管理员
          AttachmentUrl: '', //附件
          LogUrl:'',
          AttachmenFileName:''
        },
        imgHead: this.$store.state.EMP.imgPath,
        fileList: [],
        CompanyName: '',
        rules: {
          CompanyName: {
            required: true,
            message: "请选择公司主体",
            trigger: "change",
          }
        },
        legList: [],
        headPath: this.$store.state.EMP.docPath,
        personnelList: [], //人员列表
        roletype: localStorage.loginRoletype,
      };
    },
    created() {
      if (this.$route.query.row != undefined && this.$route.query.row) {
        this.formData = JSON.parse(this.$route.query.row);
        console.log(this.formData)
        this.CompanyName = this.formData.CompanyName;
        if(this.formData.AttachmentUrl){
          let item = {
            Id: new Date().valueOf().toString() + Math.random(),
            name:this.formData.AttachmentUrl,
            url: this.headPath + this.formData.AttachmentUrl
          }
          this.fileList = [item]
        }
      }
      this.getlegalsubjectlist();
      this.getauthUserInfoByorgancode();
    },
    methods: {
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      changeLeg(item) {
        this.formData.LegalId = item.value;
        this.formData.CompanyName = item.label;
      },
      //上传附件
      success_handle(file, fileList) {
        console.log(file, fileList);
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.formData.AttachmentUrl = res;
            this.formData.AttachmenFileName = file.name
          } else {
            this.$message.error('上传失败')
          }
        });
      },
      handleRemove(file) {
        this.formData.AttachmentUrl = '';
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 取消
      backHandle() {
        window.close()
        this.$router.push({
          path: "/companyProfileSet",
        });
      },
      submitForm() {
        this.$refs["comForm"].validate((valid) => {
          if (valid) {
            xz.updatecompIntroduce(this.formData).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功')
                setTimeout(() => {
                  this.backHandle()
                }, 300);
              } else {
                this.$message.error('系统出错')
              }
            })
          }
        })
      },
      handleAvatarSuccess(file) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "entimg");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.raw.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.formData.LogUrl = res;
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      //取人员列表
      getauthUserInfoByorgancode() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
          if (res.status == "ok") {
            this.personnelList = res.msg;
          } else {
            this.$message.error('获取人员列表失败')
            this.personnelList = [];
          }
        })
      },
      //选择人员
      changePerson(val,name,id){
        this.formData[id] = val.Userid;
        this.formData[name] = val.Username;
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
  }

  .upload_box {
    width: 300px;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 50px 0;
    width: 320px;
    display: flex;
    justify-content: center;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar{
    max-width: 400px;
  }

</style>
<style>
  .addCompanyProfileForm .el-input__inner {
    width: 221px;
  }
</style>